import SidebarItem from "./SidebarItem";
import { menuConfig } from "./menuConfig";
import { PanelLeftClose, PanelLeftOpen, X } from "lucide-react";
import logo from "../../../assets/logo.png";

function Sidebar({ onClose, collapsed, onToggle }) {
  return (
    <aside
      className={[
        "h-full flex flex-col bg-[#131628] text-white shadow-2xl",
        "transition-all duration-300 ease-in-out overflow-hidden",
        collapsed ? "w-[72px]" : "w-64",
      ].join(" ")}
    >
      <div
        className={`h-16 flex items-center border-b border-white/[0.08] flex-shrink-0 ${collapsed ? "justify-center px-2" : "justify-between px-4"
          }`}
      >
        {collapsed ? (
          <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-violet-500 to-indigo-600 flex items-center justify-center flex-shrink-0">
            <svg viewBox="0 0 24 24" className="w-5 h-5 fill-white">
              <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
            </svg>
          </div>
        ) : (
          <>
            <div className="flex items-center gap-2.5 min-w-0">


              <div className="flex items-center px-4 py-3">
                <img
                  src={logo}
                  alt="Logo"
                  className="h-20 w-auto"
                />
              </div>

            </div>
            <button
              onClick={onClose}
              className="lg:hidden p-1.5 rounded-lg text-slate-400 hover:text-white hover:bg-white/10 transition"
            >
              <X className="w-4 h-4" />
            </button>
          </>
        )}
      </div>

      <nav
        className="flex-1 overflow-y-auto overflow-x-hidden py-3 px-2 space-y-4"
        style={{ scrollbarWidth: "thin", scrollbarColor: "rgba(255,255,255,0.1) transparent" }}
      >
        {menuConfig.map((section, si) => (
          <div key={si}>
            {!collapsed && section.section && (
              <p className="px-3 mb-1.5 text-[10px] font-bold tracking-[0.15em] text-slate-500 uppercase">
                {section.section}
              </p>
            )}
            {collapsed && si > 0 && (
              <div className="mx-3 my-1 border-t border-white/[0.08]" />
            )}
            <div className="space-y-0.5">
              {section.items.map((item, ii) => (
                <SidebarItem
                  key={ii}
                  item={item}
                  onNavigate={onClose}
                  collapsed={collapsed}
                />
              ))}
            </div>
          </div>
        ))}
      </nav>

      <div className="hidden lg:block border-t border-white/[0.08] p-2 flex-shrink-0">
        <button
          onClick={onToggle}
          className={`w-full flex items-center py-2.5 px-3 rounded-xl text-slate-400 hover:text-white hover:bg-white/[0.07] transition text-xs font-medium ${collapsed ? "justify-center" : "gap-2.5"
            }`}
        >
          {collapsed ? (
            <PanelLeftOpen className="w-[18px] h-[18px]" />
          ) : (
            <>
              <PanelLeftClose className="w-[18px] h-[18px]" />
              <span>Collapse sidebar</span>
            </>
          )}
        </button>
      </div>
    </aside>
  );
}

export default Sidebar;